/*
 * Built with Common Launchpad 2.0.3
 */

import Vue from 'vue';
import Fragment from 'vue-fragment';
import VeeValidate from 'vee-validate'; // validation plugin
import { TooltipPlugin, AlertPlugin, CollapsePlugin, ModalPlugin } from 'bootstrap-vue';  // ui plugins
import store from '../custom-apps/store';

Vue.use(Fragment.Plugin);

// init ui plugins add/remove as needed
Vue.use(AlertPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);

// init validation plugin
Vue.use(VeeValidate, {
	events: 'change|blur',
	inject: false,
});

const dictionary = {
	en: {
		email: {
			required: () => 'Email address is required.'
		},
		phone: {
			required: () => 'Phone number is required.'
		},
	}
};

// Override and merge the dictionaries
VeeValidate.Validator.localize(dictionary);

// init app
const VueApp = new Vue({
    store,
});


let input;
let liveRegion;
let results;
let resultButtons;

window.addEventListener('DOMContentLoaded', (e) => {
    input = $('input.typeahead__search');
    liveRegion = $('.results-count.sr-only');
    if (input && input.length > 0) {
		input.on('input', (e) => {
            setTimeout(() => {
				results = $('a.typeahead__sublink');
                // Announce to screen reader users that new results are available, and remind them how to reach them.
                liveRegion.html('');  // clear the previous content so that the next line will always cause a screen reader announcement, even if the number of results is the same.
                if (results.length > 0) {
                    liveRegion.html(`${results.length} results available. Use Tab to access.`);
                    // Add `aria-current="true"` to whichever `<button>` gets activated.
                    results.forEach((button) => {
                        button.on('click', (e) => {
                            results.forEach((otherButton) => {
                                otherButton.removeAttribute('aria-current');
                            });

                            button.setAttribute('aria-current', true);
                        });
                    });
                } else {
                    liveRegion.html('No results available.');
                }
            }, 2000);
        });
    }
});

export { VueApp as default };